<template>
    <div class="info-detail-job-wrapper">
        <div class="title-header">
            <div class="title">{{data.title}}</div>
            <div class="tips">{{data.createTime}} <span class="ml20">阅读量：{{data.reading}}</span><span class="ml20" v-if="data.$type">类型：{{data.$type}}</span><span class="ml20">发布人：{{data.createUserName}}</span><span class="ml20" v-if="data.createDept">发布机构：{{data.createDeptName}}</span></div>
            <!-- <div class="info">
                <div class="i-t"></div>
                <div v-if="data.createUserName">发件人：{{data.createUserName}}</div>
                <div v-if="data.reviewerUserName">审核人：{{data.reviewerUserName}}</div>
                <div v-if="data.$type">主题：{{data.$type}}</div> 
                <div v-if="data.createDept">发布机构：{{data.createDept}}</div>
                <div v-if="data.createUserName">发布时间：{{data.createTime}}</div>
            </div> -->
        </div>
        <div class="detail" v-html="data.content"></div>
    </div>
</template>
<script>
export default {
    props: {
        info: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        info: {
            deep: true,
            handler(val) {
                this.data = this.info
                console.log(this.data)
            }
        }
    },
    data() {
        return {
            data: {}
        }
    },
    mounted() {
        this.data = this.info
    }

}

</script>
<style lang="scss" scoped>
.info-detail-job-wrapper {
    max-width: 900px;
    min-width: 900px;
    margin-right: auto;
    margin-left: auto;
    .title-header {
        border-bottom: 1px solid #eaeaea;
        margin: 0 20px
    }

    .title {
        text-align: center;
        font-size: 16px;
        color: #333;
        margin-bottom: 20px;
    }

    .tips {
        padding: 10px 0;
        font-size: 12px;
        color: #999;
        text-align: center;
    }

    .info {
        width: 400px;
        color: #999;
        line-height: 30px;
        font-size: 12px;

        .i-t {
            position: relative;
            border: 1px dashed #eaeaea;
            margin: 40px 0 30px;

            &:after {
                content: "原始信息";
                position: absolute;
                font-size: 14px;
                left: 50%;
                transform: translateX(-50%);
                top: -22px;
                padding: 10px;
                color: #666;
                line-height: 24px;
                background: #fff;

            }
        }

    }

    .detail {
        padding: 20px;
    }
}

</style>
